<template>
    <HeaderCardsLayout variant="No-Logo">
        <template #headline>{{ $t('create-dev-account') }}</template>
        <template #breadcrumb>
            <Breadcrumb :headline="$t('breadcrumb')" :current-page="$t('create-dev-account')">
                <BreadcrumbLink :target="{ name: 'users' }">
                    <UsersIcon class="mr-1 shrink-0" />
                    {{ $t('users') }}
                </BreadcrumbLink>
            </Breadcrumb>
        </template>
        <template #body>
            <UserCreateForm />
        </template>
    </HeaderCardsLayout>
</template>

<script setup lang="ts">
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue';
import BreadcrumbLink from '@/components/Breadcrumb/BreadcrumbLink.vue';
import UsersIcon from '@/components/Icon/UsersIcon.vue';
import HeaderCardsLayout from '@/components/Layout/HeaderCardsLayout.vue';
import { $t } from '@/plugins/fluent';
import { useHeadSafe } from '@unhead/vue';
import UserCreateForm from '../forms/UserCreateForm.vue';

useHeadSafe({ title: () => `${$t('create-dev-account')} - ${$t('users')}` });
</script>
